module.exports = __webpack_public_path__ + "r-v3/img/ml_11_01.19511279.jpg";